import {
  ProofOfAddressDocumentReducerAction,
  ProofOfAddressDocumentReducerCases,
  ProofOfAddressDocumentReducerState,
} from './proofOfAddressDocumentReducer.types';
import CASES from './proofOfAddressDocumentReducer.cases';

const proofOfAddressDocumentReducer = (
  state: ProofOfAddressDocumentReducerState,
  action: ProofOfAddressDocumentReducerAction
): ProofOfAddressDocumentReducerState => {
  switch (action.type) {
    case ProofOfAddressDocumentReducerCases.SET_DOCUMENT:
      return CASES[ProofOfAddressDocumentReducerCases.SET_DOCUMENT](
        state,
        action
      );

    case ProofOfAddressDocumentReducerCases.DELETE_DOCUMENT:
      return CASES[ProofOfAddressDocumentReducerCases.DELETE_DOCUMENT]();
    default:
      return state;
  }
};

export default proofOfAddressDocumentReducer;
